export const ScanConnectionStatus = {
  Active: 'active',
  Inactive: 'inactive',
} as const;

export type ScanConnectionStatus =
  (typeof ScanConnectionStatus)[keyof typeof ScanConnectionStatus];

export interface ScanConnection {
  readonly id: string;
  readonly orgId: string;
  readonly orgName: string;
  readonly displayName: string;
  readonly provider: string;
  readonly method: string;
  readonly status: ScanConnectionStatus;
}

/** Client mapping entry attached to a scan-connection. */
export interface ClientMapping {
  readonly mappingId: number;
  readonly clientId: number;
  readonly clientName: string;
  readonly externalClientId: string;
}

/** Full scan-connection detail used in the Organisations admin CRUD pages. */
export interface ScanConnectionDetail {
  readonly connectionId: number;
  readonly organizationId: number;
  readonly displayName: string;
  readonly provider: string;
  readonly method: string;
  readonly status: ScanConnectionStatus;
  readonly clientMappings: readonly ClientMapping[];
}

export interface ScanConnectionCreateRequest {
  readonly organizationId: number;
  readonly displayName: string;
  readonly provider: string;
  readonly method: string;
}

export interface ClientMappingCreateRequest {
  readonly clientId: number;
  readonly externalClientId: string;
}
